import { Bot, Info } from 'lucide-react';

import { TeamRoster } from '../components/TeamRoster';

/**
 * AI Team · Directory — the staff-facing roster of installed agents. Visible to
 * every staff role (guests are excluded from the shell). Read-only: management
 * lives under Settings → Agents (Founder/Super-Admin). Results have their own
 * page (`/ai-team/results`) reached from the sidebar sub-nav.
 */
export function AiTeamPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <Bot className="size-6" /> AI Team
        </h1>
        <p className="text-muted-foreground text-sm">
          Your organization&apos;s AI team — each agent works from your knowledge to help with its area.
        </p>
      </div>

      <div className="bg-muted/30 text-muted-foreground flex items-start gap-2 rounded-md border p-3 text-sm">
        <Info className="mt-0.5 size-4 shrink-0" />
        <p>
          <strong>Using your AI team:</strong> each agent works from your organization&apos;s
          knowledge to help with its area. This is a read-only directory — an admin manages which
          agents are available.
        </p>
      </div>

      <TeamRoster />
    </div>
  );
}
